import React, { Component } from 'react';
import { Container, Alert, Typography, Button } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * @description Error boundary wrapper for graceful error handling
 * Note: Error boundaries MUST be class components - React does not support
 * functional component error boundaries as they require componentDidCatch
 */
class InvoicePayLinkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('InvoicePayLink Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Alert severity="error" sx={{ textAlign: 'center' }}>
            <Typography variant="h6">Something went wrong</Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              We encountered an error loading this payment page. Please refresh the page or contact support.
            </Typography>
            <Button variant="outlined" sx={{ mt: 2 }} onClick={() => window.location.reload()}>
              Refresh Page
            </Button>
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

InvoicePayLinkErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default InvoicePayLinkErrorBoundary;
